/**
 * NOTICE:
 *  PLEASE CHANGE ABSOLUTELY YOUR FEATURE NAME HERE
 * ex:
 *  NAME_REDUCER = 'NAME_REDUCER'
 *   => 
 *  NAME_REDUCER = 'booking'
 */
export const NAME_REDUCER = 'channel';

/**
 * NOTICE:
 *  PLEASE CHANGE ABSOLUTELY YOUR PREFIX ACTION NAME HERE
 * ex:
 *  PREFIX_ACTIONS = 'PREFIX_ACTIONS';
 *   => 
 *  PREFIX_ACTIONS = 'booking_feature_';
 */
export const PREFIX_ACTIONS = 'channel_feature_';


export const PATH_LOADING = {
  getData: `loading.${NAME_REDUCER}.getData`,
};

export enum ZoneType {
    MAIN = 'MAIN',
    LEFT = 'LEFT',
    RIGHT = 'RIGHT',
    TOP = 'TOP',
    BOTTOM = 'BOTTOM',
}
 
export enum LayoutCode {
    MAIN_ONLY = 'LANDSCAPE',
    MAIN_TICKER_BOTTOM = 'MAIN_TICKER_BOTTOM',
    LEFT_RIGHT = 'LEFT_RIGHT',
    MAIN_RIGHT_BOTTOM = 'MAIN_RIGHT_BOTTOM',
    THREE_PORTRAITS = 'THREE_PORTRAITS',
    MAIN_PORTRAIT = 'PORTRAIT',
}
 

export enum TypeMedia {
    IMAGE = 'image',
    VIDEO = 'video',
    WEBVIEW = 'webview',
}